<template>
  <DefaultLayout>
    <div class="max-w-screen-3xl h-32 w-full rounded-lg cursor-pointer relative group" @click="goToBannerTab">
      <img :src="banner_url" class="w-full h-32 object-cover select-none" />
      <div class="opacity-0 font-manrope group-hover:opacity-50 duration-300 absolute left-0 bottom-0 right-0 h-6 z-10 flex justify-center items-center bg-gray-50 text-gray-800">
        Change Banner
      </div>
    </div>
    <div class="max-w-screen-3xl px-6 py-3.5">
      <div class="flex justify-between pb-4">
        <h2 class="text-2xl font-bold text-gray-800 font-manrope">Settings</h2>
      </div>
      <div class="bg-white text-sm cursor-default rounded border border-gray-200">
        <div class="flex h-10 -space-x-2">
          <button 
            v-for="(selectedTab, index) in tabs" 
            :key="index" 
            :class="isSelectedTab(selectedTab.routeName) ? ['text-primary border-solid border-b border-primary'] : []" 
            class="text-sm text-gray-700 cursor-pointer border-0 px-5" 
            @click="selectedTab.href ? goToExternalLink(selectedTab.href) : goToTab(selectedTab.routeName)"
          >
            {{ selectedTab.title }}
          </button>
        </div>
        <div class="border-b border-gray-200 border-solid"></div>
        <div class="px-4 py-4">
          <transition>
            <router-view></router-view>
          </transition>
        </div>
      </div>
    </div>
  </DefaultLayout>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
  import courseSocketMixin from 'mixins/sockets/courseSocketEvents';
  import { EventBus } from '../../../../utils/event-bus';

  export default Vue.extend({
    data() {
      return {
        title: '',
        section: '',
        is_school_course: false,
        banner_url: '',
      };
    },
    components: {
      DefaultLayout: () => import('layouts/default/default.vue'),
      GeneralSettings: () => import('./generalSettings'),
    },
    mixins: [courseSocketMixin],
    computed: {
      ...mapGetters([
        'getCourseDetail',
        'getRoleInCourse',
        'getProfile',
        'getCourseLayoutFullScreenStatus',
      ]),
      courseSettingsTitle() {
        const section = this.section ? `- ${this.section}` : '';
        return `${this.title} ${section} - Course Settings`;
      },
      school() {
        return this.getProfile.school;
      },
      tabs() {
        const tabs = [
          { title: 'General', routeName: 'course.settings.general' },
          { title: 'Banner', routeName: 'course.settings.banners' },
          { title: 'Integrations', routeName: 'course.settings.integrations' },
          { title: 'Participants', routeName: 'course.settings.participants' },
          
        ];
        return tabs;
      },
    },
    methods: {
      setCourseSettings() {
        this.title = this.getCourseDetail.title;
        this.course_is_archived = this.getCourseDetail.is_archived;
        this.section = '';
        this.is_school_course = this.getCourseDetail.school_id !== null;
        if (
          this.getCourseDetail.sections &&
          this.getCourseDetail.sections.length
        )
          this.section = this.getCourseDetail.sections[0];
      },
      goToTab(routeName) {
        this.$router.push({ name: routeName });
      },
      isSelectedTab(tabName) {
        return this.$route.name === tabName;
      },
      backToPrevious() {
        let route = {
          name: 'course.roundtables.default',
          params: { courseID: this.$route.params.courseID },
        };
        if (this.course_is_archived || this.$route.query.dashboard)
          route = { name: 'dashboard' };
        return this.$router.push(route);
      },
      goToBannerTab() {
        this.$store.commit('setFecthComponent', true);
        const route = {
          name: 'course.settings.banners',
          params: {
            courseID: this.getCourseDetail.id,
          },
        };
        this.$router.push(route);
      },
    },
    mounted: async function() {
      this.banner_url = this.getCourseDetail.banner_url;
      this.setupCourseSocket(this.$route.params.courseID);
      const course = await this.$store.dispatch('fetchCourseDetails', this.$route.params.courseID);
      if (course){
        this.setCourseSettings();
        this.banner_url = course.banner_url;
      }
      EventBus.$on('changeBannerTemporary', (banner) => {
        this.banner_url = banner.pathLong;
      });
      EventBus.$on('removeTemporaryBanner', () => {
        this.banner_url = this.getCourseDetail.banner_url;
      });
    },
    beforeDestroy() {
      this.leaveCourseSocket(this.$route.params.courseID);
    },
  });
</script>
<style scoped lang="stylus">
  .course-settings-body
    min-height: calc(100vh - 240px);
  .tab-body
    min-height: calc(100vh - 342px);
</style>



// WEBPACK FOOTER //
// settings.vue?08e8813f